import Icon from './Icon';
import type { IconName } from '@/theme/icons';

/**
 * Ported from src/components/ui/FAB.tsx. accessibilityLabel is required, as it is on the
 * native one: an icon-only control with no name is invisible to assistive tech.
 */
export default function FAB({ icon = 'add', onPress, accessibilityLabel }: {
  icon?: IconName;
  onPress: () => void;
  accessibilityLabel: string;
}) {
  return (
    <button type="button" onClick={onPress} aria-label={accessibilityLabel} className="fab pressable clay-primary">
      <Icon name={icon} size={28} color="var(--color-surface)" />
    </button>
  );
}
